import { Helmet } from 'react-helmet-async';
import React from 'react';
import { getOrgTermsContent } from '../../content/utils.js';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';
import ProjectDashboardContainer from '../../containers/projects/ProjectDashboardContainer.jsx';

const ProjectDashboard = ({ projectId }) => (
  <>
    <Helmet>
      <title>{getOrgTermsContent('project')} | ChangeSync</title>
    </Helmet>
    <ProjectDashboardContainer projectId={projectId} />
  </>
);

ProjectDashboard.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
});

export default requireAuth(withRouterParams(ProjectDashboard));
